module.exports = __webpack_public_path__ + "static/media/dark-forest.a23cc9cc.jpg";